module.exports = __webpack_public_path__ + "static/media/Muli-ExtraLight.fe0a7604.ttf";